import styled from 'styled-components';

const Select = styled.select`
  padding: ${({ theme }) => theme.form.inputPadding};
  min-width: ${({ theme }) => theme.form.inputMinWidth};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text};

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary || theme.colors.buttonBg};
  }
`;

export default Select;